// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom right / auto 40vh, rgb(232, 231, 227);
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Monaco', monospace;
  position: absolute;
  margin: 0;
  padding: 0;
  overflow: auto;
  z-index: 0;
}

.login-image {
  display: block;
  margin: 0 auto;
  width: 35%;
  margin-bottom: 5%;
}

.login-container {
  margin: 5%;
  width: 100%;
  max-width: 500px; 
  padding: 30px; 
  background-color: transparent;
  border: none;
  text-align: center;
}

.login-input {
  box-sizing: border-box;
  width: 100%; 
  padding: 15px;
  margin: 10px 0; 
  background-color: rgb(255, 255, 255);    
  border: 0px solid #a2d2ff;
  border-radius: 10px; 
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
  font-family: 'Monaco', monospace;
}

.login-button {
  width: 80%;
  padding: 15px;
  margin-top: 20px;
  color: black;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease; 
  font-family: 'Monaco', monospace;
}

.login-error {
  color: #ff6961;
  margin-bottom: 10px;
  font-weight: bold;
}

.form-group {
  position: relative;
  margin-bottom: 20px;
}

.password-toggle-button {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
}

.login-recovery {
  margin-top: 2%;
  color: blue; 
  text-decoration: underline;
}

.social-buttons-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 5%;
  margin-bottom: 15%;
}

.socialButton {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0 !important;
  max-width: 9%;
  min-width: 50px;
  border-radius: 10px !important;
  box-shadow: 0 4px 8px rgba(0,0,0,0.5) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.socialButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.7);
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,0GAAmG;EACnG,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,gDAAgD;EAChD,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC","sourcesContent":[".login-page {\n  background: url('../assets/background.webp') no-repeat bottom right / auto 40vh, rgb(232, 231, 227);\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Monaco', monospace;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  z-index: 0;\n}\n\n.login-image {\n  display: block;\n  margin: 0 auto;\n  width: 35%;\n  margin-bottom: 5%;\n}\n\n.login-container {\n  margin: 5%;\n  width: 100%;\n  max-width: 500px; \n  padding: 30px; \n  background-color: transparent;\n  border: none;\n  text-align: center;\n}\n\n.login-input {\n  box-sizing: border-box;\n  width: 100%; \n  padding: 15px;\n  margin: 10px 0; \n  background-color: rgb(255, 255, 255);    \n  border: 0px solid #a2d2ff;\n  border-radius: 10px; \n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \n  font-family: 'Monaco', monospace;\n}\n\n.login-button {\n  width: 80%;\n  padding: 15px;\n  margin-top: 20px;\n  color: black;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease; \n  font-family: 'Monaco', monospace;\n}\n\n.login-error {\n  color: #ff6961;\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n.form-group {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.password-toggle-button {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.login-recovery {\n  margin-top: 2%;\n  color: blue; \n  text-decoration: underline;\n}\n\n.social-buttons-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin-top: 5%;\n  margin-bottom: 15%;\n}\n\n.socialButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0 !important;\n  max-width: 9%;\n  min-width: 50px;\n  border-radius: 10px !important;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.5) !important;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.socialButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(0,0,0,0.7);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
